import type React from "react";
import styled from "styled-components";
import { getTheme, themed, } from "@bracket/ui";

const StyledInput = styled.input`
	flex: 1;
	background-color: transparent;
	border: none;
	color: ${() => getTheme().surface_on};
	font-size: 2rem;
	text-align: right;
	margin-right: 1rem;
	font-family: ${() => getTheme().fonts.numeric};

	&:focus {
		outline: none;
	}

	&::-webkit-inner-spin-button,
	&::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	-moz-appearance: textfield;
`;

type InputProps = {
	value: string;
	onChange: (value: string) => void;
	placeholder?: string;
	type?: string;
	disabled?: boolean;
	pattern?: string;
};

export const Input: React.FC<InputProps> = ({
	value,
	onChange,
	placeholder = "0.0",
	type = "number",
	disabled,
	pattern,
	...props
}) => {
	themed();
	return <StyledInput type={type} value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} disabled={disabled} pattern={pattern} {...props} />;
};

export default Input;
